//@flow
import FunctionStore from '../Base/functionStoreClass';
import { setFlag, apiUpdateState, updateState } from '../Base/storeUtils';
import Constants from '../../constants';
import Api from '../../APIInterfaces/creditCards';
import MembershipApi from '../../APIInterfaces/membership';
import CreditCardsCollection from './creditCardsCollection';
import { toImmutable } from '../../Utils/immutable';
import GlobalData from '../../Utils/globalData';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export default class CreditCardsStore extends FunctionStore {
  getCreditCards():CreditCardsCollection {
    return this._resolvePropertyObject('creditcards', CreditCardsCollection, Api.getCreditCards);
  }

  checkoutPaymentMethodModalIsOpen():boolean {
    return this._getFlag('checkoutPaymentMethodModalIsOpen');
  }

  isAmazonLoaded():boolean {
    return this._getFlag('amazonLoaded');
  }

  getAmazonBillingId():?string {
    return this.getState().get('amazonBillingId', null);
  }

  getStripeInstance():?Object {
    return this.getState().get('stripeInstance', null);
  }

  getAcceptInstance():?Object {
    return this.getState().get('acceptInstance', null);
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.GET_CREDIT_CARDS_SUCCESS, apiUpdateState(_getCreditCardsResponse));

    onSuccess(Constants.ADD_CREDIT_CARD, _addCreditCard);
    onSuccess(Constants.ADD_CREDIT_CARD_SUCCESS, [ setFlag('checkoutPaymentMethodModalIsOpen', false), Api.getCreditCards ]);

    onSuccess(Constants.OPEN_CHECKOUT_PAYMENT_METHOD_MODAL, setFlag('checkoutPaymentMethodModalIsOpen', true));
    onSuccess(Constants.CLOSE_CHECKOUT_PAYMENT_METHOD_MODAL, setFlag('checkoutPaymentMethodModalIsOpen', false));

    onSuccess(Constants.SET_AMAZON_LOADED, setFlag('amazonLoaded', true));
    onSuccess(Constants.SET_AMAZON_BILLING_ID, updateState(_setAmazonBillingId));
    onSuccess(Constants.SET_MEMB_TO_USE_CREDIT_CARD, _setMembToUseCreditCard);
    onSuccess(Constants.SET_STRIPE_INSTANCE, updateState(_setStripeInstance));
    onSuccess(Constants.SET_ACCEPT_INSTANCE, updateState(_setAcceptInstance));
  }
}

function _setAmazonBillingId(state:StoreState, data:{ billingId:string }) {
  state.set('amazonBillingId', data.billingId);
}

function _setStripeInstance(state:StoreState) {
  state.set('stripeInstance', window.Stripe(GlobalData.get('stripeApiKey')));
}

function _setAcceptInstance(state:StoreState) {
  state.set('acceptInstance', window.Accept);
}

function _setMembToUseCreditCard(store:FunctionStore, data:{ membershipId:string, cardId:string }) {
  MembershipApi.updateMembership(data.membershipId, {
    payment_data: {
      vault_id: data.cardId,
    },
  });
}

function _getCreditCardsResponse(state:StoreState, data:Object) {
  state.set('creditcards', toImmutable(data));
}

function _addCreditCard(store:FunctionStore, data:Object) {
  Api.addCard(data);
}
